import { Link, useLocation } from "react-router";
import { AI_DASHBOARDS_PATH, CHAT_PATH } from "@/constants";

export function AnalyticsDeprecationNotice() {
  const { pathname } = useLocation();
  const isLegacyAnalyticsPath = ["/pinboard", "/answer"].some(
    (path) => pathname === path || pathname.startsWith(`${path}/`),
  );

  if (!isLegacyAnalyticsPath) return null;

  return (
    <aside
      aria-label="Analytics deprecation notice"
      role="status"
      className="flex w-full shrink-0 items-start gap-3 border-b border-amber-200 bg-amber-50 px-5 py-3 text-amber-950 sm:px-8"
    >
      <svg
        aria-hidden="true"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.7"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="mt-0.5 size-5 shrink-0 text-amber-700"
      >
        <circle cx="12" cy="12" r="9" />
        <path d="M12 7v5M12 16h.01" />
      </svg>
      <p className="m-0 text-sm leading-6">
        <strong className="font-semibold">This page will be deprecated in two weeks.</strong> Please
        refer to{" "}
        <Link
          to={AI_DASHBOARDS_PATH}
          className="font-semibold underline underline-offset-2 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-amber-700"
        >
          AI Dashboards
        </Link>{" "}
        or the{" "}
        <Link
          to={CHAT_PATH}
          className="font-semibold underline underline-offset-2 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-amber-700"
        >
          Foodics AI agent
        </Link>{" "}
        for your analytics. All dashboards have been copied to AI Dashboards. If you can't find a
        dashboard or something feels wrong, please contact support.
      </p>
    </aside>
  );
}
